<template>
  <div>
    <div class="stock stock--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <StockHeader @searchStock="setSearchStock"></StockHeader>
      <ProductFamilyList class="categories--stock"></ProductFamilyList>
      <div class="stock__products">
        <ProductStock :item="item" v-if="item.stock != 0 || (item.stock == 0 && item.restocking == 1)" v-for="item in filteredStock" :key="item.id"></ProductStock>
      </div>
    </div>
  </div>
</template>

<script>

import StockHeader from "@/components/Stock/StockHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import ProductStock from "@/components/Product/ProductStock";

export default {
  name: "Stock",
  data() {
    return {
      stock: [],
      filteredStock: [],
      searchedWord: '',
    };
  },
  created(){
    const self = this;
    this.$store.dispatch('showLoader');
    this.getStockProducts();
  },
  computed: {
  },
  mounted() {
    this.$store.dispatch("vehicle/getMyVehicleStock").then(() => {
      this.getStockProducts();
      this.$store.dispatch('hideLoader');
    });
  },
  methods: {
    setSearchStock(searchedWord){
      this.searchedWord = searchedWord
      this.searchFilter(this.searchedWord)
    },
    searchFilter(s){
      const self = this;
      const regex = new RegExp(s.toLowerCase().replace(/\s/g, ".*"), "gi");
      self.filteredStock = self.stock.vehicle_stocks.filter(vs => {
        if(vs.product.label.toLowerCase().match(regex) || vs.product.code.toLowerCase().match(regex)){
          return vs;
        }
     })
   },
   getStockProducts(){
     const self = this;
     self.stock = this.$store.getters["vehicle/getMyVehicleStock"];
     self.filteredStock = self.stock.vehicle_stocks;
   },
   resetSearch(){
     this.$refs.keyword.value = ''
   }
  },
  components: {
    StockHeader,
    ProductFamilyList,
    ProductStock
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .stock{
    .swiper-container{
    }
    .swiper-container--tech{ margin-top: 0; }
    &__products{ padding: 20px; }
  }

</style>



// WEBPACK FOOTER //
// src/components/Stock/Stock.vue